import React, { Component } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { View, Button, Image } from '@zhike/ti-ui';
import { countWords } from 'utils';
import { Article } from '@zhike/ti-component';
import RenderIndex from 'components/report/common/render_index';
import styles from './styles';
import imgAnswerAnalysis from './assets/answerAnalysis.png';


export default class Report extends Component {
  // 参数
  static propTypes = {
    questions: PropTypes.array.isRequired,
    question: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      isHide: false,
      isReport: true,
    };
  }

  // 渲染
  render() {
    const { question, questions, match } = this.props;
    const { isHide, isReport } = this.state;
    const direction = get(question, 'materials[0].direction');
    const stem = get(question, 'stem');
    const origin = get(question, 'materials[0].origin');
    const userAnswer = get(question, 'materials.0.userAnswer.answer.text');
    const wordCount = get(question, 'materials.0.userAnswer.answer.wordCount');
    const analysis = get(question, 'materials.0.analysis');
    const examples = get(question, 'materials.0.examples.0.text');
    const modelEssay = get(question, 'materials.0.examples.0.text.paragraphs.0.text');
    const essayCount = modelEssay && countWords(modelEssay);
    return (
      <View className={styles.container}>
        <View className={styles.left}>
          <View className={styles.result}>
            <RenderIndex
              questions={questions}
              question={question}
              match={match}
            />
            <View className={styles.content}>
              {
                direction &&
                  <Article
                    isReport={isReport}
                    material={direction}
                  />
              }
              {
                origin &&
                  <Article
                    isReport={isReport}
                    material={origin}
                  />
              }
              {
                stem &&
                  <Article
                    isReport={isReport}
                    material={stem}
                  />
                }
            </View>
          </View>
        </View>
        <View className={styles.rigth}>
          <View className={styles.analysis}>
            <View className={styles.div}>
              <View className={styles.title2}>
                <View className={styles.buttons}>
                  <Button
                    text="我的作文"
                    textClassName={isHide === true ? styles.buttonText : []}
                    className={[
                      styles.button,
                      styles.buttonLeft,
                      isHide === false ? styles.buttonActive : [],
                    ]}
                    onClick={() => {
                      this.setState({
                        isHide: false,
                      });
                    }
                    }
                  />
                  <Button
                    text="参考范文"
                    textClassName={isHide === false ? styles.buttonText : []}
                    className={[
                      styles.button,
                      styles.buttonRight,
                      isHide === true ? styles.buttonActive : [],
                    ]}
                    onClick={() => {
                      this.setState({
                        isHide: true,
                      });
                    }
                    }
                  />
                </View>
                <View className={styles.count}>
                  Word Count :
                  {
                    isHide === false &&
                    (wordCount === undefined ? 0 : wordCount)
                  }
                  {
                    isHide === true &&
                    (essayCount === undefined ? 0 : essayCount)
                  }
                </View>
              </View>
            </View>
            {
              isHide === false &&
              <View className={styles.textRigth}>
                {
                  userAnswer &&
                  <View className={styles.text1}>
                    {userAnswer}
                  </View>
                }
                {
                  <View className={styles.title1}>
                    <View className={styles.icon} />
                    <View className={styles.answerAnalysis}>答案解析</View>
                  </View>
                }
                {
                  (!analysis ||
                  !analysis.paragraphs ||
                  (Array.isArray(analysis.paragraphs) && analysis.paragraphs.length === 0)) &&
                    <View className={[styles.text1, styles.textContent]}>
                      <Image src={imgAnswerAnalysis} className={styles.image} />
                      <View>暂无解析</View>
                    </View>
                }
                {
                  analysis &&
                    <Article
                      material={analysis}
                      isReport={isReport}
                    />
                }
              </View>
            }
            {
              isHide === true &&
              <View className={styles.textRigth1}>
                {
                  examples && JSON.stringify(examples) !== '{}' &&
                  <Article
                    isReport={isReport}
                    material={examples}
                  />
                }
                {
                  (!examples || JSON.stringify(examples) === '{}') &&
                  <View className={styles.text}>
                    <Image src={imgAnswerAnalysis} className={styles.image} />
                    <View>暂无参考译文</View>
                  </View>
                }
                {
                  <View className={styles.title1}>
                    <View className={styles.icon} />
                    <View className={styles.answerAnalysis}>答案解析</View>
                  </View>
                }
                {
                  (!analysis ||
                  !analysis.paragraphs ||
                  (Array.isArray(analysis.paragraphs) && analysis.paragraphs.length === 0)) &&
                    <View className={[styles.text1, styles.textContent]}>
                      <Image src={imgAnswerAnalysis} className={styles.image} />
                      <View>暂无解析</View>
                    </View>
                }
                {
                  analysis &&
                    <Article
                      material={analysis}
                      isReport={isReport}
                    />
                }
              </View>
            }
          </View>
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/base_report/writing_report/index.js